// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FlowHeading_wrapper__G3y3V","icon":"FlowHeading_icon__6oKmh","progress":"FlowHeading_progress__of_W5","heading":"FlowHeading_heading__6kDaD"};